import React, { useState, useEffect } from 'react';
import { Droppable, DragDropContext, Draggable } from 'react-beautiful-dnd';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StrictModeDroppable = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);
  if (!isMounted) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Droppable, __spreadValues({}, props), children);
};
function useDragAndDrop(data, options) {
  const [items, setItems] = useState();
  const [isDragDisabled, setIsDragDisabled] = useState((options == null ? void 0 : options.isDragDisabled) || false);
  useEffect(() => {
    if (data) {
      setItems(data);
    }
  }, [data]);
  function reorder(items2, startIndex, endIndex) {
    const orderedItems = [...items2];
    const [removed] = orderedItems.splice(startIndex, 1);
    orderedItems.splice(endIndex, 0, removed);
    return orderedItems;
  }
  function onDragEnd(result) {
    var _a;
    if (!result.destination || result.destination.index === result.source.index || !items) {
      return;
    }
    const reorderedItems = reorder(items, result.source.index, result.destination.index);
    setItems([...reorderedItems]);
    (_a = options == null ? void 0 : options.onDragEnd) == null ? void 0 : _a.call(options, reorderedItems);
  }
  const DragAndDropList = ({ children }) => {
    return /* @__PURE__ */ React.createElement(DragDropContext, {
      onDragEnd
    }, /* @__PURE__ */ React.createElement(Droppable, {
      droppableId: "droppable"
    }, (provided) => /* @__PURE__ */ React.createElement("div", __spreadValues({
      ref: provided.innerRef
    }, provided.droppableProps), items == null ? void 0 : items.map((item, idx) => {
      const draggableId = item.id.toString();
      return /* @__PURE__ */ React.createElement(Draggable, {
        index: idx,
        draggableId,
        key: `${draggableId}-${idx}`,
        isDragDisabled
      }, (provided2, snapshot) => /* @__PURE__ */ React.createElement("div", __spreadProps(__spreadValues(__spreadValues({
        ref: provided2.innerRef
      }, provided2.draggableProps), provided2.dragHandleProps), {
        "aria-label": `${idx}`,
        "data-testid": `draggable-item-${draggableId}`
      }), children({
        item,
        index: idx,
        isDragging: snapshot.isDragging
      })));
    }), provided.placeholder)));
  };
  return {
    DragAndDropList,
    items,
    setItems,
    isDragDisabled,
    setIsDragDisabled
  };
}

export { StrictModeDroppable, useDragAndDrop };
//# sourceMappingURL=useDragAndDrop.es.js.map
